<!DOCTYPE html>
<template>
<div>
    <!-- Loader Start -->
        <!-- Hero Start -->
        <section class="bg-home bg-primary d-flex align-items-center" style="background: url('http://cbpass.cn-bj.ufileos.com/exam%2Fbg6.png') center center; height: auto;" id="home">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 text-center mt-0 mt-md-5 pt-0 pt-md-5">
                        <div class="title-heading margin-top-100">
                            <h1 class="display-4 font-weight-bold text-white mb-3 pt-5">云原生数字化教育系统</h1>
                            <p class="para-desc mx-auto text-white-50">IpeakExam Cloud Native Digital Edu System</p>
                            <p class="para-desc mx-auto text-white-50">集云端在线课程学习、练习、考试、互动参与为一体的云原生数字化教育系统，为用户搭建“学+练+考+评”全生态链服务体系，提供全方位的、全生命周期的在线培训考试解决方案</p>
                            <div class="watch-video mt-4">
                                 <a href="https://pc.ipeakexam.com" class="btn btn-success mb-2 mr-2" target="_blank">立即免费试用</a>
                                <a href="tel:+86400-110-1175" class="btn btn-danger mb-2" target="_blank"><i class="mdi mdi-phone mr-2"></i>咨询电话: 400-110-1175</a>
                                <!-- <a href="http://vimeo.com/99025203" class="video-play-icon watch text-light mb-2 ml-2"><i class="mdi mdi-play play-icon-circle text-center bg-success d-inline-block mr-2 rounded-pill text-white position-relative play play-iconbar"></i> 观看使用指南 !</a> -->
                            </div>
                        </div>

                        <div class="row justify-content-center">
                            <div class="col-lg-7 col-md-10">
                                <div class="home-dashboard">
                                    <img src="http://cbpass.cn-bj.ufileos.com/exam%2FDigital.abaf6722.svg" alt="" style="top: 0;" class="img-fluid">
                                </div>
                            </div>
                        </div>
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end container--> 
        </section><!--end section-->
        <div class="position-relative">
            <div class="shape overflow-hidden text-light">
                <img src="../assets/images/bottom-shape.png" class="img-fluid" alt="">
            </div>
        </div>
        <!-- Hero End -->
        


        <section class="section pt-0" id="service">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12">
                        <div class="section-title text-center mb-4 pb-2">
                            <h4 class="title mb-4">系统核心优势</h4>
                            <!-- <p class="para-desc mx-auto text-muted mb-0">帮助大中小学、幼儿园等各级各类学校和社会教育培训机构更有效地、更便捷地完成考试练习（如随堂练习、单元测试、升学考试）、课程学习、培训考核、结业测评等，包括但不限于包括但不限于爱国教育，党建测评；人员招录、问卷调查、团建活动知识竞答；升学考试、期末期中测试、单元小测、随堂练习，心理测评，安全教育，普法教育等学校类；安全生产、机械操作规范等生产操作类等</p> -->
                        </div>
                    </div><!--end col-->
                </div><!--end row-->

                <div class="row">
                    <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                        <div class="feature position-relative text-center">
                            <div class="p-4 rounded position-relative overflow-hidden">
                                <div class="icon text-primary">
                                    <i class="mdi mdi-flash-outline"></i>
                                    <img src="../assets/images/shape-1.png" class="avatar avatar-small icon-shape spin-anything" alt="">
                                </div>
                                <div class="content mt-4">
                                    <h5><a href="javascript:void(0)" class="title text-dark">懂科技</a></h5>
                                    <p class="text-muted">人工智能、区块链、云计算、大数据等高端前沿科学技术，为传统学考模式带来颠覆性变革</p>
<!--                                    <a href="javascript:void(0)" class="text-primary">更多 <i data-feather="chevron-right" class="fea icon-sm"></i></a>-->
                                </div>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                        <div class="feature position-relative text-center">
                            <div class="p-4 rounded position-relative overflow-hidden">
                                <div class="icon text-primary">
                                    <i class="mdi mdi-test-tube"></i>
                                    <img src="../assets/images/shape-1.png" class="avatar avatar-small icon-shape spin-anything" alt="">
                                </div>
                                <div class="content mt-4">
                                    <h5><a href="javascript:void(0)" class="title text-dark">懂考试</a></h5>
                                    <p class="text-muted">稳定流畅的系统叠加全流程服务，做您身边的在线学考专家</p>
<!--                                    <a href="javascript:void(0)" class="text-primary">更多 <i data-feather="chevron-right" class="fea icon-sm"></i></a>-->
                                </div>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                        <div class="feature position-relative text-center">
                            <div class="p-4 rounded position-relative overflow-hidden">
                                <div class="icon text-primary">
                                    <i class="mdi mdi-human-edit"></i>
                                    <img src="../assets/images/shape-1.png" class="avatar avatar-small icon-shape spin-anything" alt="">
                                </div>
                                <div class="content mt-4">
                                    <h5><a href="javascript:void(0)" class="title text-dark">懂用户</a></h5>
                                    <p class="text-muted">模块化服务购买、私有化部署，满足您对培训考试系统的个性化需求</p>
<!--                                    <a href="javascript:void(0)" class="text-primary">更多<i data-feather="chevron-right" class="fea icon-sm"></i></a>-->
                                </div>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                        <div class="feature position-relative text-center">
                            <div class="p-4 rounded position-relative overflow-hidden">
                                <div class="icon text-primary">
                                    <i class="mdi mdi-desktop-mac"></i>
                                    <img src="../assets/images/shape-1.png" class="avatar avatar-small icon-shape spin-anything" alt="">
                                </div>
                                <div class="content mt-4">
                                    <h5><a href="javascript:void(0)" class="title text-dark">懂体验</a></h5>
                                    <p class="text-muted">良好交互体验的电脑端、移动端（APP、小程序)，轻量级适配更多需求场景</p>
<!--                                    <a href="javascript:void(0)" class="text-primary">更多 <i data-feather="chevron-right" class="fea icon-sm"></i></a>-->
                                </div>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                        <div class="feature position-relative text-center">
                            <div class="p-4 rounded position-relative overflow-hidden">
                                <div class="icon text-primary">
                                    <i class="mdi mdi-reminder"></i>
                                    <img src="../assets/images/shape-1.png" class="avatar avatar-small icon-shape spin-anything" alt="">
                                </div>
                                <div class="content mt-4">
                                    <h5><a href="javascript:void(0)" class="title text-dark">懂需求</a></h5>
                                    <p class="text-muted">智能批量导入，辅以海量行业题库，方便您的所有不方便</p>
<!--                                    <a href="javascript:void(0)" class="text-primary">更多 <i data-feather="chevron-right" class="fea icon-sm"></i></a>-->
                                </div>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                        <div class="feature position-relative text-center">
                            <div class="p-4 rounded position-relative overflow-hidden">
                                <div class="icon text-primary">
                                    <i class="mdi mdi-emoticon-outline"></i>
                                    <img src="../assets/images/shape-1.png" class="avatar avatar-small icon-shape spin-anything" alt="">
                                </div>
                                <div class="content mt-4">
                                    <h5><a href="javascript:void(0)" class="title text-dark">懂服务</a></h5>
                                    <p class="text-muted">用户遍及全国各地，广泛分布于教育、金融、房地产、新零售等垂直行业及政府机关、企事业单位</p>
<!--                                    <a href="javascript:void(0)" class="text-primary">更多 <i data-feather="chevron-right" class="fea icon-sm"></i></a>-->
                                </div>
                            </div>
                        </div>
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end container-->

            <!-- <div class="container mt-100 mt-60">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-6 order-2 order-md-1 mt-4 pt-2 mt-sm-0 opt-sm-0">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-6 col-6">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <div class="card rounded border-0 shadow overflow-hidden">
                                            <img src="../assets/images/about/ab01.jpg" class="img-fluid" alt="Image">
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12 mt-4 pt-2">
                                        <div class="card rounded border-0 shadow overflow-hidden">
                                            <img src="../assets/images/about/ab02.jpg" class="img-fluid" alt="Image">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-6">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <div class="card rounded border-0 shadow overflow-hidden">
                                            <img src="../assets/images/about/ab03.jpg" class="img-fluid" alt="Image">
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12 mt-4 pt-2">
                                        <div class="card rounded border-0 shadow overflow-hidden">
                                            <img src="../assets/images/about/ab04.jpg" class="img-fluid" alt="Image">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="col-lg-6 col-md-6 col-12 order-1 order-md-2">
                        <div class="section-title ml-lg-5">
                            <h6 class="text-primary font-weight-normal mb-3">关于我们</h6>
                            <h4 class="title mb-4">我们的故事: iPeakExam</h4>
                            <p class="text-muted mb-0"></p>

                            <div class="row">
                                <div class="col-lg-6 mt-4 pt-2">
                                    <div class="media align-items-center rounded shadow p-3">
                                        <i data-feather="airplay" class="fea text-primary"></i>
                                        <h6 class="ml-3 mb-0"><a href="javascript:void(0)" class="text-dark">责任</a></h6>
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-4 pt-2">
                                    <div class="media align-items-center rounded shadow p-3">
                                        <i data-feather="download" class="fea text-primary"></i>
                                        <h6 class="ml-3 mb-0"><a href="javascript:void(0)" class="text-dark">社区</a></h6>
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-4 pt-2">
                                    <div class="media align-items-center rounded shadow p-3">
                                        <i data-feather="user" class="fea text-primary"></i>
                                        <h6 class="ml-3 mb-0"><a href="javascript:void(0)" class="text-dark">支持</a></h6>
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-4 pt-2">
                                    <div class="media align-items-center rounded shadow p-3">
                                        <i data-feather="codepen" class="fea text-primary"></i>
                                        <h6 class="ml-3 mb-0"><a href="javascript:void(0)" class="text-dark">开发</a></h6>
                                    </div>
                                </div>
                                <div class="col-12 mt-4 pt-2">
                                    <div class="watch-video">
                                        <a href="javascript:void(0)" class="btn btn-primary mb-2 mr-2">更多 <i data-feather="chevron-right" class="fea icon-sm"></i></a>
                                        <a href="http://vimeo.com/99025203" class="video-play-icon watch title-dark text-dark mb-2"><i class="mdi mdi-play play-icon-circle text-center d-inline-block mr-2 rounded-pill text-white title-dark position-relative play play-iconbar"></i>观看视频</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- <div class="container mt-100 mt-60">
                <div class="row justify-content-center">
                    <div class="col-12">
                        <div class="section-title text-center mb-4 pb-2">
                            <h4 class="title mb-4">价格体系</h4>
                            <p class="text-muted para-desc mx-auto mb-0">根据不同的行业和使用者，我们制定了不同的价格方案供您参考</p>
                        </div>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-lg-3 col-md-6 col-12 mt-4 pt-2">
                        <div class="pricing text-center rounded overflow-hidden shadow">
                            <div class="price-header bg-dark pt-5 pb-5">
                                <h5 class="price-title text-white">社区版</h5>
                                <p class="mb-0 text-white-50">社区版具有基本的功能</p>
                            </div>
                            <div class="d-flex justify-content-center bg-light border-bottom py-4">
                                <span class="h6 mb-0">¥</span>
                                <span class="price h4 mb-0 ml-1">0.00</span>
                                <span class="h6 align-self-end mb-1">/年</span>
                            </div>
                            <div class="pricing-features text-left">
                                <ul class="feature list-unstyled py-4 p-3 mb-0">
                                    <li class="feature-list text-muted"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>云端部署</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>基本的功能</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>受限的存储空间</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>无免费域名</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>支持最大20人账号上限</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>不支持其他增值业务</li>
                                </ul>
                                <div class="border-top text-center py-4">
                                    <a href="javascript:void(0)" class="btn btn-dark">免费使用</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6 col-12 mt-4 pt-2">
                        <div class="pricing text-center rounded overflow-hidden shadow">
                            <div class="price-header bg-dark pt-5 pb-5">
                                <h5 class="price-title text-white">教育机构版</h5>
                                <p class="mb-0 text-white-50">专为教育机构使用者使用</p>
                            </div>
                            <div class="d-flex justify-content-center bg-light border-bottom py-4">
                                <span class="h6 mb-0">¥</span>
                                <span class="price h4 mb-0 ml-1">35.99</span>
                                <span class="h6 align-self-end mb-1">/人年</span>
                            </div>
                            <div class="pricing-features text-left">
                                <ul class="feature list-unstyled py-4 p-3 mb-0">
                                    <li class="feature-list text-muted"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>云端部署/私有化部署</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>完全的功能</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>私有化的存储空间</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>一个免费域名</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>人数不设上限</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>需要教育机构资质</li>
                                </ul>
                                <div class="border-top text-center py-4">
                                    <a href="javascript:void(0)" class="btn btn-dark">立即咨询</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6 col-12 mt-4 pt-2">
                        <div class="pricing text-center rounded overflow-hidden shadow-lg bg-light">
                            <div class="price-header bg-primary pt-5 pb-5">
                                <h5 class="price-title text-white">企业版</h5>
                                <p class="mb-0 text-light">企业用户</p>
                            </div>
                            <div class="d-flex justify-content-center bg-light border-bottom py-5">
                                <span class="h6 mb-0">¥</span>
                                <span class="price h4 mb-0 ml-1">41.99</span>
                                <span class="h6 align-self-end mb-1">/人年</span>
                            </div>
                            <div class="pricing-features text-left">
                                <ul class="feature list-unstyled py-4 p-3 mb-0">
                                    <li class="feature-list text-muted"><i data-feather="arrow-right-circle" class="fea icon-sm text-primary mr-2"></i>云端部署/私有化部署</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-primary mr-2"></i>完全的功能</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-primary mr-2"></i>私有化的存储空间</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-primary mr-2"></i>一个免费域名</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-primary mr-2"></i>人数不设上限</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-primary mr-2"></i>无需教育机构资质</li>
                                </ul>
                                <div class="border-top text-center py-5">
                                    <a href="javascript:void(0)" class="btn btn-primary">立即咨询</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6 col-12 mt-4 pt-2">
                        <div class="pricing text-center rounded overflow-hidden shadow">
                            <div class="price-header bg-dark pt-5 pb-5">
                                <h5 class="price-title text-white">专业版</h5>
                                <p class="mb-0 text-white-50">具有全部的功能</p>
                            </div>
                            <div class="d-flex justify-content-center bg-light border-bottom py-4">
                                <span class="h6 mb-0">¥</span>
                                <span class="price h4 mb-0 ml-1">45.99</span>
                                <span class="h6 align-self-end mb-1">/人年</span>
                            </div>
                            <div class="pricing-features text-left">
                                <ul class="feature list-unstyled py-4 p-3 mb-0">
                                    <li class="feature-list text-muted"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>云端部署/私有化部署</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>完全的功能</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>私有化的存储空间</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>无限二级域名数量</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>人数不设上限</li>
                                    <li class="feature-list text-muted mt-2"><i data-feather="arrow-right-circle" class="fea icon-sm text-dark mr-2"></i>强大的多路实时监考功能</li>
                                </ul>
                                <div class="border-top text-center py-4">
                                    <a href="javascript:void(0)" class="btn btn-dark">立即咨询</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Review Start -->
            <!-- <div class="container mt-100 mt-60">
                <div class="row justify-content-center">
                    <div class="col-12">
                        <div class="section-title text-center mb-4 pb-2">
                            <h4 class="title mb-4">产品优势</h4>
                                 <p class="text-muted para-desc mx-auto mb-0"><strong>稳定流畅的系统+全流程服务+大数据分析</strong></p>
                                <p class="text-muted para-desc mx-auto mb-0">懂考试，做您身边的在线考试专家</p><br/>
                                <p class="text-muted para-desc mx-auto mb-0"><strong>本地私有化系统部署+模块化组装</strong></p>
                                <p class="text-muted para-desc mx-auto mb-0">懂用户，满足您对考试系统的个性化需求</p>
                                <p class="text-muted para-desc mx-auto mb-0"><strong>多端适配+全场景融合</strong></p>
                                 <p class="text-muted para-desc mx-auto mb-0">懂体验，PC、小程序轻量级适配更多需求场景</p>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mt-4">
                        <div id="customer-testi" class="owl-carousel owl-theme">
                            <div class="customer-testi m-2">
                                <div class="content p-3 shadow rounded bg-white position-relative">
                                    <ul class="list-unstyled mb-0 text-warning">
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                    </ul>
                                    <p class="text-muted mt-2">公司产品（爱拼考在线考试系统）官网、在线版平台端和用户端，均采用与高等级信息安全保护标准的DigiCert DV SSL证书，确保用户发送数据信息的安全，不被监听、截取和篡改</p>
                                </div>
                                <div class="media mt-3 align-items-center">
                                    <img src="../assets/images/client/01.jpg" class="avatar avatar-small mr-3 rounded shadow" alt="">
                                    <p class="text-primary mb-0">- Calvin Carlo <small class="text-muted d-block ml-2">Manager</small></p>
                                </div>
                            </div>

                            <div class="customer-testi m-2">
                                <div class="content p-3 shadow rounded bg-white position-relative">
                                    <ul class="list-unstyled mb-0 text-warning">
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                    </ul>
                                    <p class="text-muted mt-2">公司核心技术团队与国内知名高校的软件安全领域教授联合研发，共同打造产品安全防火墙。</p>
                                </div>
                                <div class="media mt-3 align-items-center">
                                    <img src="../assets/images/client/02.jpg" class="avatar avatar-small mr-3 rounded shadow" alt="">
                                    <p class="text-primary mb-0">- Christa Smith <small class="text-muted d-block ml-2">Manager</small></p>
                                </div>
                            </div>

                            <div class="customer-testi m-2">
                                <div class="content p-3 shadow rounded bg-white position-relative">
                                    <ul class="list-unstyled mb-0 text-warning">
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                    </ul>
                                    <p class="text-muted mt-2">爱拼考在线考试系统采用Java语言搭建历经“双11”等高并发场景的产品技术架构，基于Docker集群部署模式，结合负载均衡技术，用尽可能少的服务器提供更稳定优质的在线培训考试技术服务，尤其是巨量用户规模下，爱拼考在线考试系统的技术优势将进一步凸显</p>
                                </div>
                                <div class="media mt-3 align-items-center">
                                    <img src="../assets/images/client/03.jpg" class="avatar avatar-small mr-3 rounded shadow" alt="">
                                    <p class="text-primary mb-0">- Jemina CLone <small class="text-muted d-block ml-2">Manager</small></p>
                                </div>
                            </div>

                            <div class="customer-testi m-2">
                                <div class="content p-3 shadow rounded bg-white position-relative">
                                    <ul class="list-unstyled mb-0 text-warning">
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                    </ul>
                                    <p class="text-muted mt-2">" According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero Launch your campaign and benefit from our expertise. "</p>
                                </div>
                                <div class="media mt-3 align-items-center">
                                    <img src="../assets/images/client/04.jpg" class="avatar avatar-small mr-3 rounded shadow" alt="">
                                    <p class="text-primary mb-0">- Smith Vodka <small class="text-muted d-block ml-2">Manager</small></p>
                                </div>
                            </div>

                            <div class="customer-testi m-2">
                                <div class="content p-3 shadow rounded bg-white position-relative">
                                    <ul class="list-unstyled mb-0 text-warning">
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                        <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                                    </ul>
                                    <p class="text-muted mt-2">" According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero Launch your campaign and benefit from our expertise. "</p>
                                </div>
                                <div class="media mt-3 align-items-center">
                                    <img src="../assets/images/client/05.jpg" class="avatar avatar-small mr-3 rounded shadow" alt="">
                                    <p class="text-primary mb-0">- Cristino Murfi <small class="text-muted d-block ml-2">Manager</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- Review End -->

            <div class="container mt-100 mt-60">
                <div class="row">
                    <div class="col-md-6 col-12">
                      <div class="faq-container">
                        <h6 class="question"><i data-feather="help-circle" class="fea icon-ex-md text-primary mr-2"></i>安全稳定的培训考试系统</h6>
                        <p class="answer text-indent text-muted mt-3 mb-0">采用服务网格构建高并发场景的产品架构，提供更稳定优质的在线培训考试技术服务，尤其是巨量规模下，进一步凸显系统优势。产品官网、在线平台端和用户端（电脑端、APP、小程序）采用高等级信息安全保护标准的DigiCert DV SSL证书，确保信息数据安全传输</p>
                      </div>

                    </div><!--end col-->
                    
                    <div class="col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                      <div class="faq-container">
                        <h6 class="question"><i data-feather="help-circle" class="fea icon-ex-md text-primary mr-2"></i>丰富多样的题库管理功能</h6>
                        <p class="answer text-indent text-muted mt-3 mb-0">支持多种题型、一键导入试题、智能灵活组卷，满足多元化考试需求。用户自建题库，海量内容一键上传。输入试题、答案解析、知识点标签等，轻松组织上岗考试、结业考试、培训考试等。搭建企业知识库，云安全存储客户的人员、课程、试题、考试、练习、互动参与等资料</p>
                      </div>
                    </div><!--end col-->
                    
                    <div class="col-md-6 col-12 mt-4 pt-2">
                      <div class="faq-container">
                        <h6 class="question"><i data-feather="help-circle" class="fea icon-ex-md text-primary mr-2"></i>智能高效的考试管理功能</h6>
                        <p class="answer text-indent text-muted mt-3 mb-0">考前人脸核验、公安联网识别，考中随机抓拍、多路实时音视频监考，最大程度地杜绝远程考试的作弊行为。固定、随机、混合等多种组卷形式，实现同考不同题、同题不同序，类似驾照科目一考试。支持免登录、口令登录、付费考试练习、指定人员考试练习等参加方式。单点登录、断电续考，考试强霸屏、限制切屏次数，禁止复制转发</p>
                      </div>
                    </div><!--end col-->
                    
                    <div class="col-md-6 col-12 mt-4 pt-2">
                      <div class="faq-container">
                        <h6 class="question"><i data-feather="help-circle" class="fea icon-ex-md text-primary mr-2"></i>简单便捷的课程管理功能</h6>
                        <p class="answer text-muted mt-3 mb-0 text-indent">多终端直播授课、师生抢麦互动、讲解白板互动、录播观看。课程关联考试、关联练习、独立存在。支持免登录、口令登录、付费观看、指定人员学习等学习方式。禁止复制转发录屏、霸屏观看，检测视频播放状态、切屏自动停播。支持打卡学习、自动播放视频、限制快进、限制观看次数、自主选择视频清晰度</p>
                      </div>
                    </div><!--end col-->
                </div><!--end row-->

                <div class="row mt-md-5 pt-md-3 mt-4 pt-2 justify-content-center">
                    <div class="col-12 text-center">
                        <div class="section-title">
                            <h4 class="title mb-4">如您有任何问题，敬请7*24h与我们联系</h4>
                            <a href="tel:+86400-110-1175" class="btn btn-primary mt-4"><i class="mdi mdi-phone"></i>咨询电话: 400-110-1175</a>
                        </div>
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end container-->
        </section><!--end section-->

     
   
</div>
</template>

<script>


export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.text-indent{text-indent: 2em  }
</style>
